import { createContext, useState } from "react";
import ReactSwitch from "react-switch";

import Weather from "./Weather";

import "./App.css";
export const ThemeContext = createContext(null);

function App() {
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    setTheme((curr) => (curr === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div className="App" id={theme}>
        <Weather defaultCity="Kharkiv" />
        <footer>
          <small>
            {" "}
            This project was coded by Veronika Potochniak and is{" "}
            <a
              href="https://github.com/nikakh13/nika-weather-app-react"
              target="_blank"
              rel="noreferrer"
              className="special-text"
            >
              open-sourced
            </a>{" "}
            on GitHub
          </small>
        </footer>
        <div className="d-flex justify-content-end fixed-bottom mb-2 me-2">
          <ReactSwitch
            onChange={toggleTheme}
            checked={theme === "dark"}
            offColor="#452b1a"
            onColor="#272727"
            uncheckedIcon={false}
            checkedIcon={false}
            activeBoxShadow={null}
          />
        </div>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
